import { DatasourceType } from '@selfai-platform/pipeline-common';

export interface DataSourceApi {
  accessLevel: 'write' | 'read' | 'writeRead';
  creationDateTime: string;
  id: string;
  ownerId: string;
  ownerName: string;
  params: DataSourceParamsType;
}
export interface DataSourceParamsBasic {
  datasourceType: DatasourceType;
  name: string;
  visibility: 'privateVisibility' | 'publicVisibility';
  properties: string;
}

export type DataSourceParamsType = Partial<DataSourceLibraryParams> &
  Partial<DataSourceS3Params> &
  Partial<DataSourceKafkaParams> &
  Partial<DataSourceHdParams> &
  Partial<DataSourceGoogleSpParams> &
  Partial<DataSourceExFilesParams> &
  Partial<DataSourceJdbcParams> &
  Partial<DataSourceHiveParams>;

export interface DataSourceLibraryParams extends DataSourceParamsBasic {
  [DataSourceParamsName.LIBRARY]: {
    libraryPath: string;
    fileFormat: 'csv';
    csvFileFormatParams: {
      includeHeader: boolean;
      convert01ToBoolean: boolean;
      separatorType: 'comma';
      customSeparator: string;
    };
  };
}

export interface DataSourceS3Params extends DataSourceParamsBasic {
  [DataSourceParamsName.S3]: {
    endpoint: string;
    accessKey: string;
    secretKey: string;
    bucket: string;
    pattern: string;
    withoutSSL: boolean;
  };
}

export interface DataSourceKafkaParams extends DataSourceParamsBasic {
  [DataSourceParamsName.KAFKA]: {
    brokers: string;
    topic: string;
    sslEnabled: boolean;
  };
}

export interface DataSourceHdParams extends DataSourceParamsBasic {
  [DataSourceParamsName.HDFS]: {
    hdfsPath: string;
    fileFormat: string;
    csvFileFormatParams: {
      includeHeader: boolean;
      convert01ToBoolean: boolean;
      separatorType: 'comma';
      customSeparator: string;
    };
  };
}

export interface DataSourceGoogleSpParams extends DataSourceParamsBasic {
  [DataSourceParamsName.GOOGLE_SP]: {
    googleSpreadsheetId: string;
    googleServiceAccountCredentials: string;
    includeHeader: boolean;
    convert01ToBoolean: boolean;
  };
}

export interface DataSourceExFilesParams extends DataSourceParamsBasic {
  [DataSourceParamsName.EX_FILE]: {
    url: string;
    fileFormat: 'csv';
    csvFileFormatParams: {
      includeHeader: boolean;
      convert01ToBoolean: boolean;
      separatorType: 'comma';
      customSeparator: string;
    };
  };
}

export interface DataSourceJdbcParams extends DataSourceParamsBasic {
  [DataSourceParamsName.JDBC]: {
    driver: string;
    url: string;
    query: string;
    table: string;
  };
}

export interface DataSourceHiveParams extends DataSourceParamsBasic {
  [DataSourceParamsName.HIVE]: {
    query: string;
    table: string;
  };
}

export type DataSourceConnectionParams =
  | DataSourceParamsType['libraryFileParams']
  | DataSourceParamsType['externalFileParams']
  | DataSourceParamsType['googleSpreadsheetParams']
  | DataSourceParamsType['hdfsParams']
  | DataSourceParamsType['jdbcParams']
  | DataSourceParamsType['s3Params']
  | DataSourceParamsType['kafkaParams']
  | DataSourceParamsType['externalFileParams']
  | DataSourceParamsType['hiveParams'];

export const DataSourceParamsName = {
  JDBC: 'jdbcParams',
  EX_FILE: 'externalFileParams',
  GOOGLE_SP: 'googleSpreadsheetParams',
  HDFS: 'hdfsParams',
  KAFKA: 'kafkaParams',
  LIBRARY: 'libraryFileParams',
  S3: 's3Params',
  HIVE: 'hiveParams',
} as const;

export type DataSourceParamsName = (typeof DataSourceParamsName)[keyof typeof DataSourceParamsName];
